import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LabelsContext from "../../../lang/LabelsContext";
import Colors from "../../../utils/Colors";
import EnumOverral from "../../../utils/enum/EnumOverral";
import EnumReviewPercent from "../../../utils/enum/EnumReviewPercent";
import EnumYesNo from "../../../utils/enum/EnumYesNo";
import { muiControls } from "../../../utils/Utils";
import HtmlTooltip from "../../system/html-tooltip/HtmlTooltip";
import RichText from "../../system/rich-text/RichText";
import ArticleCard from "../article-card/ArticleCard";
import { commentToEditor, reviewComments, reviewSaveButtons } from "../manuscript/submit/TooltipText";
import ReviewService, { ReviewServiceType } from "./ReviewService";
import useStyles from "./ReviewStyle";

export default function Review() {
  const { Labels } = LabelsContext();
  const classes = useStyles();

  const {
    article,
    reviewState,
    setReviewState,
    submitReview,
    showBlockUI,
    generalRef,
    majorRef,
    minorRef,
    commentsAbstractRef,
    commentsTablesRef,
    commentsFiguresRef,
    commentsReferencesRef,
    commentsToEditorRef,
  }: ReviewServiceType = ReviewService();
  const qualityOdResearch = [
    { name: "Significance of the research", value: "significance" },
    { name: "Orginality of research", value: "originality" },
    { name: "Experimental design and quality of data", value: "design" },
    { name: "Impact on clinical practice", value: "impact" },
    { name: "Relevance/interest to rhinology", value: "relevance" },
    { name: "Quality of abstract", value: "abstractQuality" },
    { name: "Conclusions", value: "conclusions" },
    { name: "Adequate referencing", value: "referencing" },
    { name: "If adequately revised the potential rating of the paper could be", value: "rating" },
  ];

  const otherNotes = [
    {
      name: "Is there any question of violation of the journals policy on research involving animals and human beings?",
      value: "violation",
    },
    { name: "Is an editorial needed?", value: "editorialNeeded" },
    { name: "if an editorial is needed, are you willing to write one within 2 weeks?", value: "volunteer" },
  ];

  return (
    <Grid container alignItems="center" direction="column">
      <Paper className={classes.paper}>
        {article && (
          <Grid item xs={12} sm={12} style={{ marginBottom: "10px" }}>
            <ArticleCard data={article} index={0} animation={true} linkDisable={true} />
          </Grid>
        )}
        <Grid container direction="row">
          <Grid item>
            <Typography variant="h5" style={{ marginBottom: "10px" }}>
              {"Quality of research"}
            </Typography>
          </Grid>
          <Grid container style={{ marginBottom: "20px" }}>
            <Grid container justifyContent="flex-start" alignItems="center" xs={8}>
              {""}
            </Grid>
            <Grid container justifyContent="center" alignItems="center" xs={4}>
              <Grid item xs={2} style={{ textAlign: "left" }}>
                {"Top"}
                <br />
                {"10%"}
              </Grid>
              <Grid item xs={2} style={{ textAlign: "left" }}>
                {"Top"}
                <br />
                {"25%"}
              </Grid>
              <Grid item xs={2} style={{ textAlign: "left" }}>
                {"Top"}
                <br />
                {"50%"}
              </Grid>
              <Grid item xs={2} style={{ textAlign: "left" }}>
                {"Low"}
                <br />
                {"50%"}
              </Grid>
              <Grid item xs={2} style={{ textAlign: "left" }}>
                {"Low"}
                <br />
                {"25%"}
              </Grid>
              <Grid item xs={2} style={{ textAlign: "left" }}>
                {"N/A"}
              </Grid>
            </Grid>
          </Grid>
          {qualityOdResearch.map((qualityItem: any) => {
            return (
              <>
                <FormControl component="fieldset" fullWidth>
                  <Grid container>
                    <Grid container justifyContent="flex-start" alignItems="center" xs={8}>
                      <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                        {qualityItem.name}
                      </FormLabel>
                    </Grid>
                    <Grid container justifyContent="center" alignItems="center" xs={4}>
                      <RadioGroup
                        row
                        aria-label="gender"
                        name={qualityItem.name}
                        value={reviewState[qualityItem.value]}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          setReviewState({
                            ...reviewState,
                            [qualityItem.value]: event.target.value,
                          });
                        }}
                      >
                        {Object.keys(EnumReviewPercent).map((percent: any) => {
                          return (
                            <Grid item xs={2}>
                              <FormControlLabel
                                value={percent}
                                checked={reviewState[qualityItem.value] === percent}
                                control={<Radio color="primary" />}
                                disabled={showBlockUI}
                                label=""
                              />
                            </Grid>
                          );
                        })}
                      </RadioGroup>
                    </Grid>
                  </Grid>
                </FormControl>
                <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
              </>
            );
          })}
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container direction="column">
          <Grid item>
            <Typography variant="h5" style={{ marginBottom: "10px" }}>
              {"Overal Recommendation"}
            </Typography>
          </Grid>

          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="overal"
              value={reviewState.recommendation}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setReviewState({
                  ...reviewState,
                  recommendation: event.target.value,
                });
              }}
            >
              <Grid container>
                <Grid xs={11} container justifyContent="flex-start" alignItems="center">
                  <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                    {"Acceptance (publishable as it is)"}
                  </FormLabel>
                </Grid>
                <Grid item xs={1}>
                  <FormControlLabel
                    value={EnumOverral.ACCEPTANCE}
                    checked={reviewState.recommendation === EnumOverral.ACCEPTANCE}
                    control={<Radio color="primary" />}
                    disabled={showBlockUI}
                    label=""
                  />
                </Grid>
              </Grid>
              <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
              <Grid container>
                <Grid xs={11} container justifyContent="flex-start" alignItems="center">
                  <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                    {"Conditional acceptance (needs minor changes indicated in comments)"}
                  </FormLabel>
                </Grid>
                <Grid item xs={1}>
                  <FormControlLabel
                    value={EnumOverral.CONDITIONAL_ACCEPTANCE}
                    checked={reviewState.recommendation === EnumOverral.CONDITIONAL_ACCEPTANCE}
                    control={<Radio color="primary" />}
                    disabled={showBlockUI}
                    label=""
                  />
                </Grid>
              </Grid>
              <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
              <Grid container>
                <Grid xs={11} container justifyContent="flex-start" alignItems="center">
                  <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                    {"Minor revision (needs minor/moderate revisions and further review)"}
                  </FormLabel>
                </Grid>
                <Grid item xs={1}>
                  <FormControlLabel
                    value={EnumOverral.MINOR_REVISION}
                    checked={reviewState.recommendation === EnumOverral.MINOR_REVISION}
                    control={<Radio color="primary" />}
                    disabled={showBlockUI}
                    label=""
                  />
                </Grid>
              </Grid>
              <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
              <Grid container>
                <Grid xs={11} container justifyContent="flex-start" alignItems="center">
                  <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                    {"Major revision (needs substantial revisions and further review)"}
                  </FormLabel>
                </Grid>
                <Grid item xs={1}>
                  <FormControlLabel
                    value={EnumOverral.MAJOR_REVISION}
                    checked={reviewState.recommendation === EnumOverral.MAJOR_REVISION}
                    control={<Radio color="primary" />}
                    disabled={showBlockUI}
                    label=""
                  />
                </Grid>
              </Grid>
              <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
              <Grid container>
                <Grid xs={11} container justifyContent="flex-start" alignItems="center">
                  <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                    {"Rejection (unlikely to be acceptable even after major revisions)"}
                  </FormLabel>
                </Grid>
                <Grid item xs={1}>
                  <FormControlLabel
                    value={EnumOverral.REJECTION}
                    checked={reviewState.recommendation === EnumOverral.REJECTION}
                    control={<Radio color="primary" />}
                    disabled={showBlockUI}
                    label=""
                  />
                </Grid>
              </Grid>
              <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
              <Grid container>
                <Grid xs={11} container justifyContent="flex-start" alignItems="center">
                  <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                    {"Rejection, inappropriate (not appropriate for this journal)"}
                  </FormLabel>
                </Grid>
                <Grid item xs={1}>
                  <FormControlLabel
                    value={EnumOverral.REJECTION_INAPPROPRIATE}
                    checked={reviewState.recommendation === EnumOverral.REJECTION_INAPPROPRIATE}
                    control={<Radio color="primary" />}
                    disabled={showBlockUI}
                    label=""
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
          <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container direction="row">
          <Grid item>
            <Typography variant="h5" style={{ marginBottom: "10px" }}>
              {"Other Notes"}
            </Typography>
          </Grid>
          <Grid container>
            <Grid container justifyContent="flex-start" alignItems="center" xs={10}>
              {""}
            </Grid>
            <Grid container justifyContent="space-evenly" alignItems="center" xs={2}>
              <Grid item style={{ textAlign: "center" }}>
                {"Yes"}
              </Grid>
              <Grid item style={{ textAlign: "center", marginRight: 30 }}>
                {"No"}
              </Grid>
            </Grid>
          </Grid>
          {otherNotes.map((notesItem: any) => {
            return (
              <>
                <FormControl component="fieldset" fullWidth>
                  <Grid container>
                    <Grid container justifyContent="flex-start" alignItems="center" xs={10}>
                      <FormLabel component="legend" style={{ color: Colors.BLACK }}>
                        {notesItem.name}
                      </FormLabel>
                    </Grid>
                    <Grid container justifyContent="space-around" alignItems="center" xs={2}>
                      <RadioGroup
                        row
                        aria-label="gender"
                        name={notesItem.name}
                        defaultValue={reviewState[notesItem.value]}
                        value={reviewState[notesItem.value]}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          setReviewState({
                            ...reviewState,
                            [notesItem.value]: event.target.value,
                          });
                        }}
                      >
                        {[EnumYesNo.YES, EnumYesNo.NO].map((answer: any) => {
                          return (
                            <FormControlLabel
                              value={answer.toString()}
                              checked={reviewState[notesItem.value] === answer.toString()}
                              control={<Radio color="primary" />}
                              disabled={showBlockUI}
                              style={{ color: Colors.BLACK }}
                              label=""
                            />
                          );
                        })}
                      </RadioGroup>
                    </Grid>
                  </Grid>
                </FormControl>
                <Divider style={{ marginTop: "10px", marginBottom: "10px", width: "100%" }} />
              </>
            );
          })}
        </Grid>
      </Paper>

      <Grid container justifyContent="flex-start" className={classes.marginTop2}>
        <HtmlTooltip title={reviewComments}>
          <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
        </HtmlTooltip>
      </Grid>
      <Grid container className={classes.form}>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"General Comments"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={generalRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
        </Grid>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"Major Comments"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={majorRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
        </Grid>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"Minor Comments"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={minorRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
        </Grid>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"Abstract Comments"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={commentsAbstractRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
        </Grid>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"Table Comments"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={commentsTablesRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
        </Grid>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"Figure Comments"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={commentsFiguresRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
        </Grid>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"References Comments"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={commentsReferencesRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
          <Divider style={{ marginTop: "50px", marginBottom: "50px" }} />
        </Grid>
        <Grid container className={classes.marginTop2}>
          <HtmlTooltip title={commentToEditor}>
            <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
          </HtmlTooltip>
        </Grid>
        <Grid item className={classes.marginTop2}>
          <Grid container justify="space-evenly">
            <Typography variant="h5">{"Comments to the editor"}</Typography>
          </Grid>
          <RichText
            muiEditorRef={commentsToEditorRef}
            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
            readOnly={showBlockUI}
            controls={muiControls}
            visible={!showBlockUI}
          />
        </Grid>
        <Grid container spacing={1} justifyContent="space-between" direction="row" className={classes.marginTop2}>
          <Grid container>
            <HtmlTooltip title={reviewSaveButtons}>
              <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
            </HtmlTooltip>
          </Grid>
          {!showBlockUI && (
            <Grid container spacing={1} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" color="primary" onClick={submitReview}>
                  Send to Editor in Chief
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
